// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1g9QB","title":"ClientReferral_title__2f2w9","itemText":"ClientReferral_itemText__3DdkK"};